module.exports = __webpack_public_path__ + "static/mesh-bg-horizontal-fd3d90a720f686a0132d62b20a0e966b.png";